/* eslint eqeqeq: "off" */
import React from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CorreoForm from './CorreoForm';

import {  useParams } from "react-router-dom";
import { Segment} from 'semantic-ui-react'; 
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment'; 
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as correoActions from '../../actions/correoActions';
import * as inscripcionActions from '../../actions/inscripcionActions';
import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import {getMargenes} from '../../util/';
import RichTextEditor from 'react-rte';
import * as menuActions from '../../actions/menuActions';

class ManageCorreo extends React.Component {

    constructor(props, context){

        super(props, context);
     
		this.state={
            errors:{},
            curso:[],
            strings:{},
            permisos:{},
            correos:{
                cursoId:0,
                alumnoId:[]
            },
            value: RichTextEditor.createEmptyValue(),
		};
		
	}
    
 
    componentDidMount(){
        usuarioActual(this, "correo",true).then( (usuario)=>{
            window.scrollTo(0, 0);
            this.props.cursoActions.getCursoCombo(usuario).then(()=>{
                
            }).catch(error=>{ 
                  toastr.error(error); 
            }); 
        
        }).catch(error=>{
          toastr.error(error);
        });
		
    }


    onSend=()=>{
        
        let envio = Object.assign({}, this.state.correos);
        envio.mensaje = this.state.value.toString('html');
        
        
        
        
        if(envio.cursoId>0 && envio.mensaje.length>15){
            
            toastr.success("Preparando para envio de correos!!");
            this.props.correoActions.mensaje(envio, this.props.user).then(()=>{

                toastr.success("Correos enviados!!!");

            }) .catch(error=>{ 
              toastr.error(error); 
            });
        }else{
            
             toastr.error("Debes seleccionar un curso y redactar un mensaje");
            
        }
    }
    
    

    handleChange=(event, data)=> {

        let correos = this.state.correos;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		correos[field[0]]= value;
		else{
             if(!correos[field[0]]){
                    correos[field[0]]={}
                }
			correos[field[0]][field[1]]= value;
		}
        
		
        if(field == 'cursoId'){
            this.props.inscripcionActions.getInscripcionUsuariosCombo(value, this.props.user).then(()=>{}) 
            .catch(error=>{ 
              toastr.error(error); 
            });
        }
        
        this.setState({"correos": correos});
    }
    
    setContent=(value)=>{
        this.setState({value:value});
        this.setState({textComment:value.toString('html')});
        
    }
    
    
      
       
    render() {	
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
          
       return (
              <Segment   style={margenes}>
                <CorreoForm 
                    user={this.props.user}
                    strings={this.props.strings}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    ajaxCallInProgress={this.props.ajaxCallInProgress} 
                    correos={this.state.correos}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    value= {this.state.value}
                    setContent={this.setContent}
                    onSend={this.onSend}
                    inscripcionCombo={genericFormattedForDropdown(this.props.inscripcionCombo)}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        color:state.color,
		permisos:state.permisos,
        form:state.form,
        strings:state.strings,
        cursoCombo:state.cursoCombo,
        user:state.user,
        inscripcionCombo:state.inscripcionCombo,
        idioma:state.idioma
    }

}

function mapDispatchToProps(dispatch){

	return { 
        menuActions:bindActionCreators(menuActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        inscripcionActions: bindActionCreators(inscripcionActions, dispatch),
        correoActions: bindActionCreators(correoActions, dispatch),
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageCorreo);